export const FIELD_OPTIONS = {
  testPyramid: ['E2E Test (UI)', 'Integration Test', 'System E2E', 'Unit Test'],
  type: ['New TestCase', 'Other', 'Regression', 'Sanity', 'Smoke'],
  priority: ['P0.5 - Business Blocker', 'P0 - Blocker', 'P1 - High', 'P2 - Medium', 'P3 - Low'],
  unit: [
    'Activation', 'Adoption', 'AI Analyst', 'AI Proactive Insights', 'AI Setup',
    'Analysis Building', 'Channel Performance', 'Content Analysis', 'Customer Journey Analysis',
    'Data Connect', 'Data Governance', 'Error Analysis', 'Experimentation', 'Growth Ops',
    'Heap App', 'Identity & Access Management', 'Integrations', 'Navigation & Design System',
    'Page Performance Analysis', 'Quality Excellence', 'SDK Capture', 'SDK Cross-Platform Core',
    'SDK Native Core', 'SDK Screen Insights', 'SDK Session Replay & Errors', 'Segmentation',
    'Subscription Experience', 'Tag Core', 'Tag Functions', 'Users & Retention', 'VoC',
  ],
  automationStatus: [
    'Automated', 'Automated as E2E', 'Automated - Skipped', 'Manual',
    'Automated - Flaky', 'Manual - Automation Not Feasible',
  ],
};

export const AUTOMATION_STATUS_OPTIONS = [
  '',
  'Automated',
  'Automated - Flaky',
  'Automated - Skipped',
  'Manual',
  'Manual - Automation Not Feasible',
  'Automated as E2E',
];

export function httpErrorMessage(err) {
  const status = err?.response?.status;
  const serverMsg = err?.response?.data?.message;
  if (status === 401) return 'Unauthorized. Please log in again.';
  if (status === 403) return 'You do not have permission to perform this action.';
  if (status === 404) return 'Resource not found.';
  if (status === 422 || status === 400) return serverMsg || 'Invalid request. Check the form values and try again.';
  if (status >= 500) return serverMsg || 'Server error. Please report issue to dev team.';
  if (!status) return 'Network error. Check your connection and try again.';
  return serverMsg || `Unexpected error (${status}). Please try again.`;
}
